import React, {useState} from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import {Form, Button, message, Skeleton, Row, Col, Popover, Checkbox, Empty} from 'antd';
import {procesarNomina, obtenerReporte, obtenerReporteDebug, conceptosReporte} from '../../../../apis/ProcesoNominaApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import {status_period} from '@app/constants/period';
import Result from './result'
import { useSelector } from 'react-redux';
import userRoles from '@app/constants/userRoles';

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Procesar Nómina</span>
      </>
    ),
  }];

const ProcesarNomina = () => {
    const [ form ] = Form.useForm()
    const [ loadingProcesar, setLoadingProcesar ] = useState(false);
    const [ loadingReporte, setLoadingReporte ] = useState(false);
    const [ loadingDebug, setLoadingDebug ] = useState(false);
    const [objectSelected, setObjectSelected] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [header, setHeader] = useState(null);
    const [periodData, setPeriodData] = useState(null);
    const [status, setStatus] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [loadingConceptos, setLoadingConceptos] = useState(false);
    const [conceptosDisp, setConceptosDisp] = useState({ grupos: [] });
    const [selectedMap, setSelectedMap] = useState({});
    const currentUser = useSelector((state) => state.Auth.currentUser);
    const isAdmin = currentUser?.role_id === userRoles.admin;

    const handleOk = async ({concepto}) => {
      setLoadingProcesar(true);
      let success = false;
      const fields = form.getFieldsValue();
      const payload = {
        ...fields
      }
      const response = await procesarNomina(payload);
      success = response.ok;
      if(response.ok){
          // setID(response.payload);
          message.success('Se proceso correctamente la nomina!');
      }
      if(success){
        window.location.reload();
        await resetBody();
      }

      setLoadingProcesar(false);
    }

    const getOrdenConceptos = () => (conceptosDisp.grupos || []).reduce(
      (acc, grupo) => acc.concat((grupo.conceptos || []).map((c) => c.clave)), []
    );

    const handleAbrirPopover = async (open) => {
      if (!open) {
        setPopoverOpen(false);
        return;
      }
      setPopoverOpen(true);
      setLoadingConceptos(true);
      try {
        const fields = form.getFieldsValue();
        const response = await conceptosReporte(fields.periodo_id, fields.anio, fields.num_periodo);
        if (response.ok) {
          const data = response.payload || { grupos: [] };
          setConceptosDisp(data);
          const todos = {};
          (data.grupos || []).forEach((grupo) => {
            (grupo.conceptos || []).forEach((c) => { todos[c.clave] = true; });
          });
          setSelectedMap(todos);
        } else {
          message.error('No se pudo obtener la lista de conceptos');
          setPopoverOpen(false);
        }
      } catch (e) {
        console.error('Error obteniendo conceptos del reporte', e);
        message.error('No se pudo obtener la lista de conceptos');
        setPopoverOpen(false);
      } finally {
        setLoadingConceptos(false);
      }
    };

    const toggleGrupo = (items, checked) => {
      setSelectedMap((prev) => {
        const next = { ...prev };
        items.forEach((item) => { next[item.clave] = checked; });
        return next;
      });
    };

    const handleGenerar = async () => {
      const seleccion = getOrdenConceptos().filter((clave) => selectedMap[clave]);
      if (seleccion.length === 0) {
        message.warning('Selecciona al menos un concepto');
        return;
      }
      setLoadingReporte(true);
      try {
        const fields = form.getFieldsValue();
        await obtenerReporte(fields.periodo_id, fields.anio, fields.num_periodo, seleccion);
        setPopoverOpen(false);
      } finally {
        setLoadingReporte(false);
      }
    };

    const renderGrupo = (titulo, items) => {
      if (!items || items.length === 0) return null;
      const todasSel = items.every((item) => selectedMap[item.clave]);
      return (
        <div style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
            <b>{titulo}</b>
            <Button type="link" size="small" style={{ padding: 0, height: 'auto' }} onClick={() => toggleGrupo(items, !todasSel)}>
              {todasSel ? 'Ninguno' : 'Todos'}
            </Button>
          </div>
          {items.map((item) => (
            <Checkbox
              key={item.clave}
              checked={Boolean(selectedMap[item.clave])}
              onChange={(e) => setSelectedMap((prev) => ({ ...prev, [item.clave]: e.target.checked }))}
              style={{ display: 'block', marginLeft: 0, marginBottom: 4 }}
            >
              {item.clave} - {item.descripcion}
            </Checkbox>
          ))}
        </div>
      );
    };

    const totalConceptos = getOrdenConceptos().length;

    const popoverContent = (
      <div style={{ width: 380 }}>
        <div style={{ maxHeight: 420, overflowY: 'auto' }}>
          {loadingConceptos ? (
            <Skeleton active paragraph={{ rows: 4 }} />
          ) : totalConceptos === 0 ? (
            <Empty description="Sin conceptos en el período" />
          ) : (
            <>
              {(conceptosDisp.grupos || []).map((grupo) => renderGrupo(grupo.descripcion, grupo.conceptos))}
            </>
          )}
        </div>
        <div style={{ marginTop: 12, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button size="small" onClick={() => setPopoverOpen(false)}>Cancelar</Button>
          <Button size="small" type="primary" loading={loadingReporte} disabled={loadingConceptos} onClick={handleGenerar}>
            Generar
          </Button>
        </div>
      </div>
    );

    const handleReporteDebug = async () => {
      setLoadingDebug(true);
      try {
        const fields = form.getFieldsValue();
        await obtenerReporteDebug(fields.periodo_id, fields.anio, fields.num_periodo);
      } finally {
        setLoadingDebug(false);
      }
    }


    const resetBody = async ()=>{
      let values = await form.getFieldValue();
      form.resetFields();
      form.setFieldsValue({
        periodo_id: values.periodo_id,
        anio: values.anio,
        num_periodo: values.num_periodo,
      });
    }

    const onBlurHeader = async (values, dataPeriod, status)=> {
      setHeader(values)
      if(values?.anio && values?.num_periodo && values?.periodo_id){
        setDisabled(false);
      }else{
        setDisabled(true);
      }

      setPeriodData(dataPeriod);
      setStatus(status?.value);
    }

    return <PageApp 
      routes={routes}
      title={'Procesar Nómina Global'}>
        <AnioPeriodo onBlur={onBlurHeader} form={form} disabledForm={objectSelected && objectSelected.id > 0}/>
        <Row gutter={16} className="mt-4 mb-4">
          <Col>
            <Button type="primary" onClick={handleOk} loading={loadingProcesar} disabled={status && (status > status_period.calculado_total)}>
              {loadingProcesar ? 'Procesando': ' Procesar Todos'}
            </Button>
          </Col>
          <Col>
            <Popover
              open={popoverOpen}
              onOpenChange={handleAbrirPopover}
              trigger="click"
              placement="bottomLeft"
              title="Conceptos del reporte"
              content={popoverContent}
            >
              <Button type="primary" loading={loadingReporte}>
                {loadingReporte ? 'Generando': ' Generar Reporte'}
              </Button>
            </Popover>
          </Col>
          {isAdmin && (
            <Col>
              <Button type="default" onClick={handleReporteDebug} loading={loadingDebug} disabled={!header || !form.getFieldValue('periodo_id') || (status && status < status_period.calculado_total)}>
                {loadingDebug ? 'Generando': ' Descargar Debug'}
              </Button>
            </Col>
          )}
        </Row>
        <br/>
        {
          (loadingProcesar || loadingReporte || loadingDebug) ? <Skeleton active={true} />: <>
            {
              header && !disabledForm && <Result header={header} />
            }
          </>
        }

    </PageApp>
}   

export default ProcesarNomina;
